import { render, staticRenderFns } from "./PriceByTypeForm.vue?vue&type=template&id=754d6ffd"
import script from "./PriceByTypeForm.vue?vue&type=script&lang=ts"
export * from "./PriceByTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports